export const audioContext = new AudioContext();

export function enable() {
  return audioContext.resume();
}
